export const APP_VERSION = 'v2.5.75'
